import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import YesNoField from "components/form_components/YesNoField";
import MROTextField from "components/form_components/TextField";
import useGetCustomerDetails from "../Hooks/useGetCustomerDetails";
import useQuoteStyles from "../utils/QuoteStyles";
import { ToastMessageContext } from "lib/contexts/message_context";

/**
 * Props:
 *  state: {
 *    customer_existing,
 *    customer_name,
 *    selected_customer,
 *    contact_email
 *  }
 *
 *  onChange(fieldName, value)
 *  customers: []   // list from API
 */
function CustomerSection(props) {
    const {
        errors,
        setErrors, resetErrorsHandler,
        disabled,
        selectedCustomerId,
        setSelectedCustomerId,
        access,
        quotation,
        handlePopup,
        salesRate,
        setSalesRate,
        setRate,
        loading,
        action,
        cusExist, setExistCus,
        currencyName,
        setCurrencyname
    } = props;
    const classes = useQuoteStyles()
    const customerDetails = useGetCustomerDetails(true);

    const [notExistsCusName, setCusNotExistsName] = useState(null);
    const [contactEmail, setContactEmail] = useState(null);
    const message = useContext(ToastMessageContext)

    useEffect(() => {
        let res = customerDetails?.default_currency?.map((item) => {
            setCurrencyname(item?.currency_name);
            setSalesRate(item?.sales_rate);
        });
    }, [customerDetails]);

    useEffect(() => {
        if (action === "Unlock") {
            if (quotation !== null) {
                let obj = {
                    id: quotation?.line_customer_id,
                    name: quotation?.customer_name,
                    currency: {
                        currency_name: quotation?.currency_name,
                        sales_rate: quotation?.sales_rate
                    }

                };
                setSelectedCustomerId(obj);
            }

            if (quotation?.linked_storage_order_id === null) {
                setExistCus(
                    quotation?.customer_existing === true
                        ? "yes"
                        : quotation?.customer_existing === false
                            ? "no"
                            : ""
                );
            }
            setContactEmail(quotation?.contact_email);
            setCusNotExistsName(quotation?.customer_name);




        }
    }, [quotation]);



    const handleExistCus = (value) => {
        handlePopup();
        if (value) {
            setExistCus(value);
        }
    };


    useEffect(() => {
        if (quotation?.linked_storage_order_id) {
            setExistCus("yes")
        }
    }, [quotation])

    useEffect(() => {
        if (cusExist === "no" && notExistsCusName) {
            if (notExistsCusName === quotation?.customer_name) {
                setExistCus('yes')
                let obj = {
                    id: quotation?.line_customer_id,
                    name: quotation?.customer_name,
                };
                setSelectedCustomerId(obj);
                console.log("notExistsCusName", quotation?.customer_name)
            }
            else {
                let udx = customerDetails?.customers.findIndex((item) => item.name === notExistsCusName)
                if (udx > -1) {
                    setErrors((er) => ({ ...er, customer_name: true }));
                    message.showToastMessage({
                        message: "Customer already exists! Selecting from existing!",
                        variant: "error",
                    });
                }
            }
        }
    }, [cusExist, notExistsCusName])
    return (
        <Grid>
            <Typography color="primary" variant="body1">Customer</Typography>



            <Grid
                style={{ marginBottom: "10px" }}
                container
                spacing={3}
                alignItems={"center"}
                justify={"flex-start"}
            >
                <Grid item xs={3}
                    style={{ background: "transparent" }}
                    className={disabled || access.read || quotation?.linked_storage_order_id != null ? classes.disableField : null}
                >
                    <YesNoField
                        disabled={disabled || !props.permission.write || quotation?.linked_storage_order_id != null}
                        label="Existing Customer?*"
                        name="customer_existing"
                        handleToggle={handleExistCus}
                        value={cusExist}
                        error={errors.customer_existing}
                        setError={() => {
                            resetErrorsHandler("customer_existing");
                        }}
                        marginTop={"-4px"}
                        marginRight={"11px"}
                    />
                </Grid>
                {cusExist === "yes" ? (
                    <Grid className={classes.purchaseGrid} item xs={3}>
                        <Autocomplete
                            disabled={disabled || !props.permission.write || quotation?.linked_storage_order_id != null}
                            getOptionSelected={(option, value) => option.id === value.id}
                            value={selectedCustomerId !== null && selectedCustomerId}
                            onChange={(event, value) => {
                                setSelectedCustomerId(value);
                                setSalesRate(value?.currency?.sales_rate)
                                setRate(value?.currency?.sales_rate)
                                handlePopup();
                            }}
                            id="tags-standard"
                            options={customerDetails?.customers || []}
                            loading={loading}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <MROTextField
                                    {...params}
                                    style={{ backgroundColor: "#fff", pointerEvents: !props.permission.write && "none" }}
                                    variant="outlined"
                                    name="customer_name"
                                    defaultValue="Select"
                                    label="Select Customer *"
                                    color={"primary"}
                                    InputProps={{
                                        ...params.InputProps,
                                        type: "search",
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    error={errors.customer_name}
                                    onSelect={() => {
                                        resetErrorsHandler("customer_name");
                                    }}
                                />
                            )}
                        />
                    </Grid>
                ) : (
                    <Grid className={classes.purchaseGrid} item xs={3}>
                        <MROTextField
                            name={"customer_name"}
                            label={"Customer Name"}
                            InputLabelProps={{ shrink: true }}
                            required
                            placeholder="Enter a customer name"
                            disabled={!props.permission.write}
                            InputProps={{
                                className: disabled && classes.disableField,
                            }}
                            value={notExistsCusName}
                            error={errors.customer_name}
                            onChange={(e) => {
                                resetErrorsHandler(e.target.name);
                                setCusNotExistsName(e.target.value);
                                handlePopup();
                            }}
                        ></MROTextField>
                    </Grid>
                )}
                <Grid className={classes.purchaseGrid} item xs={3}>
                    <MROTextField
                        name={"contact_email"}
                        label={"Contact Email"}
                        disabled={!props.permission.write}
                        InputProps={{
                            className: disabled && classes.disableField,
                        }}
                        required
                        value={contactEmail}
                        placeholder={
                            "Email address quote sends to(Comma separate Email)"
                        }
                        error={errors.contact_email}
                        autoFocus={errors.contact_email}
                        helperText={
                            errors.contact_email
                                ? "*please enter a correct email"
                                : null
                        }
                        onChange={(e) => {
                            setContactEmail(e.target.value);
                            resetErrorsHandler(e.target.name);
                            handlePopup();
                        }}
                        InputLabelProps={{ shrink: true }}
                    ></MROTextField>
                </Grid>
            </Grid>
        </Grid >
    );

}
export default CustomerSection;
